export default __webpack_public_path__ + "static/media/Textile_Apparel_Sector_Cheers.c28a16b1.png";